// Async Thunk for fetching banners
import axios from "axios";
import { createAsyncThunk } from "@reduxjs/toolkit";
const BASE_URL = process.env.REACT_APP_BASE_URL;

export const fetchProductDetails = createAsyncThunk(
  "productDetails/fetchProductDetails",
  async ({ id, lang }, { rejectWithValue }) => {
    try {
      const token = JSON.parse(localStorage.getItem("userTools"));

      const response = await axios.get(`${BASE_URL}/product/${id}`, {
        headers: {
          "Accept-Language": lang,
          Authorization: `Bearer ${token?.token}`,
        },
      });
      return response.data.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.message || "خطأ في جلب البيانات"
      );
    }
  }
);
